import angular, {
  IAttributes,
  IDirective,
  IDirectiveController,
  IScope,
} from "angular";
import AutoNumeric from "autonumeric";

export const vsDirectiveName = "autoNumericInput";

interface AutoNumericDirectiveScope extends IScope {}

export function autoNumericInputDirective(): IDirective<
  AutoNumericDirectiveScope,
  JQLite,
  IAttributes,
  IDirectiveController
> {
  return {
    restrict: "A",
    scope: false,
    require: ["?ngModel"],
    link: {
      pre: (
        scope: AutoNumericDirectiveScope,
        instanceElement: JQLite,
        attrs: IAttributes,
        controller?: IDirectiveController
      ) => {
        const controllers = <IDirectiveController[]>controller;
        const ngModelController = <angular.INgModelController>controllers.at(0);

        const options: AutoNumeric.Options = {
          decimalPlaces: getScopeValueFromAttribute(
            scope,
            attrs,
            "decimalPlaces",
            0
          ),
          upDownStep: getScopeValueFromAttribute(scope, attrs, "upDownStep", 1),
          maximumValue: getScopeValueFromAttribute(
            scope,
            attrs,
            "maximumValue",
            Number.MAX_SAFE_INTEGER
          ).toString(),
          minimumValue: getScopeValueFromAttribute(
            scope,
            attrs,
            "minimumValue",
            Number.MIN_SAFE_INTEGER
          ).toString(),
          readOnly: getScopeValueFromAttribute(scope, attrs, "readOnly", false),
        };
        const autoNumericInstance = new AutoNumeric(
          instanceElement[0],
          scope.$eval("model[options.key]"),
          options
        );

        ngModelController.$parsers.push((value: string) => {
          const unformatted = AutoNumeric.unformat(value);
          if (angular.isNumber(unformatted)) {
            return unformatted;
          }
          return Number.parseFloat(unformatted);
        });
        ngModelController.$formatters.push((value: any) =>
          AutoNumeric.format(value)
        );

        scope.$on("destroy", () => autoNumericInstance.remove());
      },
    },
  };
}

function getScopeValueFromAttribute(
  scope: IScope,
  attrs: IAttributes,
  attribute: string,
  defaultValue: any
) {
  if (attrs[attribute] === undefined) {
    return defaultValue;
  }
  return scope.$eval(attrs[attribute]) ?? defaultValue;
}
